module.exports = __webpack_public_path__ + "img/s1.9a6a1e5f.jpg";